module.exports = __webpack_public_path__ + "media/rubber_4.5e32df04.webm";